module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formField),
      expression: "formField"
    }]
  }, [(_vm.formField.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    domProps: {
      "value": (_vm.formField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formField, "value", $event.target.value)
      }
    }
  }) : (_vm.formField.type === 'date') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.dateValue),
      callback: function($$v) {
        _vm.$set(_vm.formField, "dateValue", $$v)
      },
      expression: "formField.dateValue"
    }
  }) : (_vm.formField.type === 'file') ? _c('div', [_c('span', {
    staticClass: "btn btn-default btn-file",
    attrs: {
      "disabled": _vm.showSummary
    }
  }, [_vm._v("\n      Escolher...\n      "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".pdf, .doc, .dwg, .zip, .rar, application/pdf, image/*",
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    on: {
      "change": function($event) {
        return _vm.callOnChange(_vm.formField, $event);
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formField.filename))])]) : (_vm.formField.type === 'document') ? _c('div', [_c('document-input-preview', {
    attrs: {
      "formField": _vm.formField,
      "showSummary": _vm.showSummary
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formField.filename))])], 1) : (_vm.formField.type === 'select') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.showSummary
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formField.options), function(option) {
    return _c('option', {
      key: option.code,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option.code) + " - " + _vm._s(option.name))])
  }), 0) : (_vm.formField.type === 'link') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "placeholder": "http:// ou https://",
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    domProps: {
      "value": (_vm.formField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formField, "value", $event.target.value)
      }
    }
  }) : (_vm.formField.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    domProps: {
      "value": (_vm.formField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formField, "value", $event.target.value)
      }
    }
  }) : (_vm.formField.type === 'cpf') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'cnpj') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'phone') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'number') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'money') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.currencyMask,
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name + ' em R$',
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'checkbox') ? _c('div', _vm._l((_vm.formField.options), function(option) {
    return _c('label', {
      key: option.code,
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formField.value),
        expression: "formField.value"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.showSummary
      },
      domProps: {
        "value": option,
        "checked": Array.isArray(_vm.formField.value) ? _vm._i(_vm.formField.value, option) > -1 : (_vm.formField.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formField.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.formField, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.formField, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.formField, "value", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(option.name) + "\n    ")])
  }), 0) : (_vm.formField.type === 'computed') ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": _vm.formField.objectId,
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.formField.value
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6b26602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/DynamicFormField.vue
// module id = 1470
// module chunks = 1